import React, { useState, useRef } from 'react';
import { Row, Col, Alert, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TurnstileWidget from 'Components/Shared/TurnstileWidget';

import { resetPasswordRequest } from 'Services/AuthService';

import * as yup from 'yup';
import { Formik } from 'formik';

const schema = yup.object({
    UserNameOrEmail: yup.string().required(),
});

const ForgetPassword = () => {
    const [error, setError] = useState(null);
    const [messageSent, setMessageSent] = useState(null);
    const [turnstileToken, setTurnstileToken] = useState(null);
    const turnstileRef = useRef();

    const handleSumitForm = async (formValues) => {
        if (!turnstileToken) {
            setError('Veuillez compléter la vérification CAPTCHA');
            return;
        }
        sendFormValues(formValues, turnstileToken);
    };

    const sendFormValues = async (formValues, token) => {
        try {
            setError(null);
            const {
                status,
                data: { message },
            } = await resetPasswordRequest({ ...formValues, turnstileToken: token });
            if (status === 200) {
                setMessageSent(message);
            } else throw new Error();
        } catch (err) {
            // Token is single-use — reset widget so user gets a fresh one
            setTurnstileToken(null);
            turnstileRef.current?.reset();
            const { response: { data: { message } = {} } = {} } = err;
            setError(message || 'Error occured!');
        }
    };

    return (
        <>
            <Row>
                <Col xs={12} md={{ span: 4, offset: 4 }}>
                    <div className="text-center py-3 mt-3">
                        <h2 className="mb-0">Changement de mot de passe</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {messageSent && <Alert variant="info">{messageSent}</Alert>}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={{ span: 4, offset: 4 }}>
                    {!messageSent && (
                        <Formik
                            validationSchema={schema}
                            onSubmit={(values) => handleSumitForm(values)}
                            enableReinitialize={true}
                            initialValues={{
                                UserNameOrEmail: '',
                            }}
                        >
                            {({ handleSubmit, handleChange, values, errors }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Group controlId="exampleForm.ControlUserName">
                                        <Form.Label>Nom d&apos;utilisateur ou Email</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Nom d'utilisateur ou Email"
                                            name="UserNameOrEmail"
                                            value={values.UserNameOrEmail}
                                            onChange={handleChange}
                                            isInvalid={!!errors.UserNameOrEmail}
                                        />
                                    </Form.Group>

                                    <div className="mb-3 d-flex justify-content-center">
                                        <TurnstileWidget
                                            ref={turnstileRef}
                                            siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                                            onSuccess={(token) => setTurnstileToken(token)}
                                            onError={() => {
                                                setTurnstileToken(null);
                                                turnstileRef.current?.reset();
                                            }}
                                            onExpire={() => setTurnstileToken(null)}
                                            action="CLIAM_RESET_PWD_REQ"
                                        />
                                    </div>

                                    <Button variant="primary" type="submit" block>
                                        Envoyer
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    )}
                    <Link to="/login">Retour à la page de connexion?</Link>
                </Col>
            </Row>
        </>
    );
};

export default ForgetPassword;
